module.exports = __webpack_public_path__ + "static/feature-data-d3b8777258a4a18e38c53f09818721e2.png";